document.addEventListener('click', event => {
  const element = event.target

  if (element.dataset.behavior &&
    element.dataset.behavior.includes('mortgage-down-payment')) {
    const loanAmount = parseFloat(document.querySelector('[name="loan_amount"]').value.replace(/[$,]+/g, ''))
    const numPayments = parseFloat(document.querySelector('[name="loan_length"]').value) * 12
    const interestRate = parseFloat(document.querySelector('[name="interest_rate"]').value)

    const interest = interestRate > 0 ? interestRate / 100 / 12 : 0

    const table = document.getElementById('down-payment-results')
    const percentages = [ 0, 1, 3, 5, 10, 15, 20 ]

    const tableBody = table.querySelector('tbody')

    tableBody.innerHTML = ''

    let percentage
    for (percentage of percentages) {
      const currentDownPayment = window.Calculator.getDownPaymentFromPercentage(loanAmount, percentage)
      const currentMonthlyPayment = window.Calculator.getMonthlyMortgagePayment(loanAmount - currentDownPayment, numPayments, interest)
      const downPaymentTd = document.createElement('td')
      const monthlyPaymentTd = document.createElement('td')
      downPaymentTd.innerHTML = `$${currentDownPayment.formatFloat()} (${percentage}%)`
      monthlyPaymentTd.innerHTML = `$${currentMonthlyPayment.formatFloat()}`
      const tableRow = document.createElement('tr')
      tableRow.appendChild(downPaymentTd)
      tableRow.appendChild(monthlyPaymentTd)
      tableBody.appendChild(tableRow)
    }
  }
})
